import { Modal } from "react-bootstrap";
import { enumUtil } from "../../../utils/Enum";
import { useEffect, useRef, useState } from "react";
import { ServerRequestProtected, ServerRequestPublic } from "../../../utils/ServerDataRequest";
import isNull from "../../../utils/NullChecking";
import NotificationHandler from "../../../utils/NotificationHandler";
import Loader from "../Loader/Loader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { formatFax } from "../../../utils/Formatting";
import FormatPhoneNumber from "../../../utils/FormatPhoneNumber";
import { useSelector } from "react-redux";
const MergeCreditCardForm = ({ IsOpenCreditCardForm, onClose, ID, PatientID }) => {
    const [isLoading, setIsLoading] = useState(false)
    const GENERAL_API_URL = enumUtil.controller.General
    const API_URL = enumUtil.controller.Patient
    const [Data, setData] = useState(null)
    const [imgFile, setImgFile] = useState(null)
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const componentRef = useRef(null);

    useEffect(() => {
        setIsLoading(true)
        ServerRequestProtected(GENERAL_API_URL + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeCreditCard,
            "ID": ID
        }).then((response) => {
            setIsLoading(false)
            getSignaturePreview(response?.SignaturePath)
            setData(response)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setData(null)
        })
    }, [])
    const getSignaturePreview = (SignaturePath) => {
        if (!isNull(SignaturePath)) {
            setImgFile(null);
            ServerRequestPublic(API_URL_Wasabi + "/DownloadFile",
                "post", { BucketPath: SignaturePath, }, "Download")
                .then((response) => {
                    if (response.type === "application/txt") {
                    } else if (["application/png", "application/jpg", "application/jpeg", "application/tiff"].includes(response.type)) {
                        const blob = response;
                        const objectURL = URL.createObjectURL(blob);
                        setImgFile(objectURL);
                    } else if (response.type === "application/pdf") {
                    } else {
                    }
                })
                .catch((error) => {
                    NotificationHandler("File Not Found", enumUtil.enumtoaster.error);
                });
        }
    }
    const captureDataAndGeneratePDF = async (type) => {
        setIsLoading(true);
        const element = componentRef.current;
        const originalOverflow = element.style.overflow;
        const originalBodyOverflow = document.body.style.overflow;

        try {
            // Adjust styles for capture
            element.style.overflow = 'visible';
            document.body.style.overflow = 'hidden';

            // Wait for layout to stabilize
            await new Promise(resolve => setTimeout(resolve, 300));

            // Capture the element
            const canvas = await html2canvas(element, {
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
                scale: 2,
                width: element.scrollWidth,
                height: element.scrollHeight,
                logging: false,
                allowTaint: true
            });

            // Create PDF with custom dimensions
            const imgData = canvas.toDataURL('image/jpeg', 0.8);
            const imgWidth = 210; // A4 width in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            // Create PDF with calculated height (convert mm to pt)
            const pdf = new jsPDF({
                orientation: imgHeight > imgWidth ? 'p' : 'l',
                unit: 'mm',
                format: [imgWidth, imgHeight]
            });
            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            if (type === "download") {
                pdf.save('IntakeForm.pdf');
            } else if (type === 'base64') {
                const pdfBase64 = pdf.output('datauristring');
                const formatedBase64 = pdfBase64.split(',')[1];
                return formatedBase64;
            }
        } catch (error) {
            console.error('Error generating PDF:', error);
        } finally {
            // Restore original styles
            element.style.overflow = originalOverflow;
            document.body.style.overflow = originalBodyOverflow;
            setIsLoading(false);
        }
    };
    const handleIntakeStatus = async (status, formID) => {
        let IntakeFormBase64 = await captureDataAndGeneratePDF('base64')
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/ChangeIntakeFormStatus", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "ID": ID,
            "Data": {
                IntakeStatus: "Processed",
                IntakeFormBase64: IntakeFormBase64,
                PatientID: PatientID,
                FileName: 'Credit Card Authorization.pdf'
            }
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            onClose()
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response?.data, enumUtil.enumtoaster.error)
        })
    }
    const RecoincilCreditCard = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/RecoincilCreditCard", 'post', {
            ID: Data?.PatientIntakeFormID + "",
            "TableName": enumUtil.enumAPITableName.PatientIntakeCreditCard,
            "Data": {
                PatientID: Data?.PatientID + "",
                Token: Data?.Token
            }
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            onClose()
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response?.data, enumUtil.enumtoaster.error)
        })
    }

        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <Modal show={IsOpenCreditCardForm} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="ar_merg-info-form-popup ar-merge-form-preview">
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                <div className="ar_native_pdf_design pb-15">
                    <div className="ar_print-header">
                        <div className="d-flex align-items-center justify-content-center gap-2 mb-12 pt-15 ar_print-header {">
                            <i className="icon-Icon-metro-cross fs-20" onClick={onClose}></i>
                        </div>
                        <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light px-10">
                            <p className="text fs-11 ar-light-color">Submitted on {Data?.SubmittedDate || 'N/A'} </p>
                            <div className="d-flex align-items-center gap-6">
                                <p className="text validate-color font-m pe-1-5 br-right-1 br-clr-light cursor-pointer lh-15" onClick={handleIntakeStatus}>Mark As Processed</p>
                                <p className="text validate-color font-m cursor-pointer lh-15" onClick={RecoincilCreditCard}>Reconcile All</p>
                            </div>
                        </div>
                    </div>

                    <div className='d-flex flex-column gap-10' ref={componentRef}>

                        <div className='d-flex flex-column gap-10 px-10 pt-15 pb-15'>
                            <div className="d-flex align-items-center justify-content-center pat-det-header">
                                <p className="heading text-white">Credit Card Authorization</p>
                            </div>


                            <div className="d-flex align-items-center justify-content-between">
                                <div className="">
                                    <img src={Data?.PracticeProfilePicture} alt="" style={{ maxHeight: '60px' }} crossOrigin="anonymous" />
                                </div>
                                <div className="text-center">
                                    <p className='heading validate-color fs-14'>{Data?.PracticeName || 'N/A'}</p>

                                    <p className="text text-black">{Data?.PracticeAddress || 'N/A'}</p>

                                </div>
                                <div className="d-flex gap-10">
                                    <div className="">
                                        <p className='text text-black font-m pb-2px'>Tel:</p>
                                        <p className='text text-black font-m'>Fax:</p>
                                    </div>
                                    <div className="">
                                        <p className='text text-black  pb-2px'>{FormatPhoneNumber(Data?.PracticeHomePhone)}</p>
                                        <p className='text text-black '>{formatFax(Data?.PracticeFax)}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="ar_star-form-Preview">
                                <div className="Form-content d-flex flex-column gap-10 p-0 h-100 overflow-visible">
                                    <div className="">
                                        <p className="heading fs-14 text-black mb-1">Credit Card Authorization</p>
                                        <p className="text text-black">Please complete all required fields below. By submitting this form, you authorize us to securely store your payment information and charge your card as described in this agreement.</p>
                                    </div>

                                    <div className="primary-insurance-content">
                                        <div className="content-box d-flex flex-column gap-10">
                                            <div className="d-flex align-items-center gap-15">
                                                <p className='text fs-14 text-black min-w-156px text-end ar-light-color'>Card Holder Name</p>
                                                <p className="text text-black fs-14 lh-14">{Data?.CardHolderName || 'N/A'}</p>
                                            </div>
                                            {/* <div className="d-flex align-items-center gap-15">
                                                <p className='text fs-14 text-black min-w-156px text-end ar-light-color'>Card Type</p>
                                                <p className="text text-black fs-14 lh-14 ar_dot-new align-items-center">{Data?.CardType || 'N/A'}</p>
                                            </div> */}

                                            <div className="d-flex align-items-center gap-15">
                                                <p className='text fs-14 text-black min-w-156px text-end ar-light-color'>Card Number</p>
                                                <p className="text text-black fs-14 lh-14">**************
                                                    {/* {Data?.CardNumber || 'N/A'} */}
                                                </p>
                                            </div>

                                            <div className="d-flex align-items-center gap-15">
                                                <p className='text fs-14 text-black min-w-156px text-end ar-light-color'>Expiration Date</p>
                                                <p className="text text-black fs-14 lh-14">
                                                    ***
                                                    {/* {Data?.ExpirationDate || 'N/A'} */}
                                                </p>
                                            </div>

                                            <div className="d-flex align-items-center gap-15">
                                                <p className='text fs-14 text-black min-w-156px text-end ar-light-color'>Security Code</p>
                                                <p className="text text-black fs-14 lh-14">***</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading fs-14 text-black mb-1">Authorization</p>
                                        <label className="custom_check_box d-flex gap-6">
                                            <i className="icon-check fs-15 fw-900 mt-3px"></i>
                                            <p className="text text-black user-select-none">I, <span className="heading text-black">{Data?.PatientName || 'N/A'},</span> authorize <span className="heading text-black">{Data?.PracticeName || 'N/A'}</span> to charge the credit card listed above for agreed-upon services, balances, copayments, deductibles, cancellation fees, and other charges related to my account. I understand that this authorization will remain in effect until the expiration of the credit card account. I may revoke this authorization at any time by contacting to the practice name. Revocation will not apply to charges already processed. I consent that my electronic signature below has the same legal effect as a handwritten signature for purposes of validity.</p>
                                        </label>
                                    </div>

                                    <div className="content-box">
                                        <div className="d-flex align-items-center gap-15">
                                            <p className='text fs-14 text-black min-w-156px text-end ar-light-color'>Signature</p>
                                            <div className="d-flex align-items-center gap-15 sign-content justify-content-center">
                                                <img
                                                    src={imgFile}
                                                    style={{ maxHeight: "60px" }}
                                                    alt="Uploaded preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="text-center pt-1-5 br-top-1 za_br_light print-footer mt-5">
                            <p className="text ar-light-color">By {ThemeConfiguration?.configuration?.company?.name}
                                (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer">https://starhealthcare.co</a>) </p>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default MergeCreditCardForm